module.exports = __webpack_public_path__ + "img/sosLevel2.9b5648b5.png";